import { render, staticRenderFns } from "./FormatSetTreeEditView.vue?vue&type=template&id=4f97df7c&scoped=true&"
import script from "./FormatSetTreeEditView.vue?vue&type=script&lang=ts&"
export * from "./FormatSetTreeEditView.vue?vue&type=script&lang=ts&"
import style0 from "./FormatSetTreeEditView.vue?vue&type=style&index=0&id=4f97df7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f97df7c",
  null
  
)

export default component.exports